"use client";

import { Analytics } from "@vercel/analytics/react";
import { usePathname } from "next/navigation";
import { useEffect, useState, type ReactNode } from "react";
import AppHeader from "../components/app-header";
import BackToTop from "../components/back-to-top";

const starPaths = ["/", "/categories"];

export default function SiteShell({ children }: { children: ReactNode }) {
  const pathname = usePathname();
  const [isDark, setIsDark] = useState(true);

  useEffect(() => {
    setIsDark(localStorage.getItem("isDark") !== "false");
  }, []);

  useEffect(() => {
    document.documentElement.classList.toggle("dark-theme", isDark);
  }, [isDark]);

  const toggleTheme = () => {
    const next = !isDark;
    setIsDark(next);
    localStorage.setItem("isDark", String(next));
  };

  return (
    <>
      {starPaths.includes(pathname) && isDark && <><div className="star" /><div className="star star--2" /></>}
      <div className="page_container">
        <AppHeader isDark={isDark} setIsDark={toggleTheme} />
        <div className="component_container">{children}</div>
        {pathname === "/" && isDark && <><div className="man_with_baterfly" /><div className="man_baloon" /></>}
      </div>
      {pathname !== "/" && isDark && <div className="start_back" />}
      <Analytics />
      <BackToTop />
    </>
  );
}
